import {
  createOrderMessageApi,
  getOrderMessageApi,
  sendOrderMessageApi
} from '../../api/ticket/index';
import {
  CLEAR_DATA,
  SET_MESSAGE_ORDER_DETAILS,
  SET_PAGE_LOADING,
  SET_SHOW,
  SET_TICKET_DETAILS,
  SET_TICKET_USER
} from './messageOptionConstants';

import { showCustomToast } from '../../controls/CustomToast';

export const setLoading = (isLoading) => {
  return {
    type: SET_PAGE_LOADING,
    payload: { isLoading }
  };
};

const groupByTime = (data) => {
  const groups = [];
  let currentGroup = [data[0]];

  for (let i = 1; i < data.length; i++) {
    const prevItem = data[i - 1];
    const currentItem = data[i];
    const prevDate = new Date(prevItem.created_at);
    const currentDate = new Date(currentItem.created_at);

    const diffInMinutes = (currentDate - prevDate) / (1000 * 60);

    if (diffInMinutes <= 1) {
      currentGroup.push(currentItem);
    } else {
      groups.push(currentGroup);
      currentGroup = [currentItem];
    }
  }

  groups.push(currentGroup); // Add the last group
  return groups;
};

const addShowTimeFlag = (groups) => {
  groups.forEach((group) => {
    if (group.length > 0) {
      group[group.length - 1].showTime = true;
    }
  });
};

const mergeGroups = (groups) => {
  const mergedArray = [];
  groups.forEach((group) => {
    mergedArray.push(...group);
  });
  return mergedArray;
};

export const getMessage = (order, isInitDisabledCreate = true) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: SET_MESSAGE_ORDER_DETAILS,
      payload: { orderDetails: order }
    });
    await getOrderMessageApi(order.increment_id)
      .then((res) => {
        if (!Array.isArray(res) || res.length === 0)
          return Promise.reject(
            new Error('get order message is not a valid array')
          );
        const groupedData = groupByTime(res.reverse());
        addShowTimeFlag(groupedData);
        const mergedData = mergeGroups(groupedData);
        dispatch({
          type: SET_TICKET_DETAILS,
          payload: { ticketDetails: mergedData }
        });
        dispatch({ type: SET_SHOW });
      })
      .catch(() => {
        dispatch({
          type: CLEAR_DATA,
          payload: { hasTicket: false }
        });
      })
      .finally(() => {
        if (isInitDisabledCreate) {
          dispatch({ type: SET_SHOW });
        }
        dispatch(setLoading(false));
      });
  };
};

export const sendMessage = (orderId, params) => {
  return async (dispatch) => {
    await sendOrderMessageApi(orderId, params)
      .then((res) => {
        if (!Array.isArray(res) || res.length === 0)
          return Promise.reject(
            new Error('send order message is not a valid array')
          );
        const groupedData = groupByTime(res.reverse());
        addShowTimeFlag(groupedData);
        const mergedData = mergeGroups(groupedData);
        dispatch({
          type: SET_TICKET_DETAILS,
          payload: { ticketDetails: mergedData }
        });
      })
      .catch((err) => {
        showCustomToast(err.message);
      });
  };
};

export const createMessage = (params, orderDetails) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    createOrderMessageApi(params)
      .then(async (res) => {
        dispatch({
          type: SET_TICKET_USER,
          payload: { ticketUser: res }
        });
        await dispatch(getMessage(orderDetails));
      })
      .catch((err) => {
        showCustomToast(err.message);
        dispatch(setLoading(false));
      });
  };
};
